import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Pricing() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4 text-primary-500">
            Simple, Honest Pricing
          </h1>
          <p className="text-foreground-600 max-w-xl mx-auto mb-12 font-body leading-relaxed">
            One membership. Full access. No upsells, no lock-ins, cancel anytime.
          </p>

          <div className="max-w-md mx-auto">
            <div className="bg-background-50 border-2 border-accent-400 rounded-2xl p-10 text-left relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-500 text-foreground-950 text-xs font-label font-semibold px-3 py-1 rounded-full whitespace-nowrap">
                ClearMind Club
              </div>
              <div className="text-center mb-6">
                <div className="font-heading text-5xl font-bold text-primary-500 mb-1">
                  £9.99
                  <span className="text-lg font-body font-normal text-foreground-600">/month</span>
                </div>
                <p className="text-sm text-foreground-500 font-body">Full access to everything in ClearMind Club</p>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  { icon: 'ri-lightbulb-line', label: 'Daily wellness & focus tips' },
                  { icon: 'ri-flask-line', label: 'Full nootropic review library' },
                  { icon: 'ri-calendar-check-line', label: '5+ guided wellness routines' },
                  { icon: 'ri-brain-line', label: 'Mind training exercises' },
                  { icon: 'ri-tools-line', label: 'Productivity tools & habit trackers' },
                  { icon: 'ri-trophy-line', label: 'Weekly challenges & goal setting' },
                  { icon: 'ri-question-answer-line', label: 'Q&A wellness guidance' },
                  { icon: 'ri-line-chart-line', label: 'Progress tracking dashboard' },
                  { icon: 'ri-bookmark-line', label: 'Save favourites & build your toolkit' },
                  { icon: 'ri-add-circle-line', label: 'New content added regularly' },
                ].map((item) => (
                  <li key={item.label} className="flex items-start gap-3 text-sm text-foreground-700 font-body">
                    <i className={`${item.icon} text-accent-500 text-lg mt-0.5 shrink-0`} />
                    {item.label}
                  </li>
                ))}
              </ul>

              <Link
                to="/community"
                className="w-full inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 bg-accent-500 text-foreground-950 hover:bg-accent-700 h-12 rounded-lg text-base px-8"
              >
                Join ClearMind Club
              </Link>
              <p className="text-xs text-foreground-500 mt-3 text-center font-label">
                Cancel anytime · No commitment · Educational content only
              </p>
            </div>
          </div>

          <p className="text-xs text-foreground-500 mt-8 font-label max-w-md mx-auto">
            ClearMind Club provides educational wellness and productivity content. It is not a substitute for professional medical advice. <a href="/disclaimer" className="underline text-foreground-700 hover:text-foreground-950">Read our full disclaimer</a>.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}